module.exports = __webpack_public_path__ + "static/media/468x60_0058_ru.c00ccc89.jpg";